import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// PrioritySectors component replaced on Home page with dynamic fetch
import PrioritySectorCard from '../../components/PrioritySectors/PrioritySectorCard';
import api from '../../utils/api';
import '../../components/PrioritySectors/PrioritySectors.css';
import './Home.css';
import EventCarousel from '../../components/Event/EventCarousel';
import VoiceOfItahari from '../../components/Voiceofitahari/Voiceofitahari.jsx';

import itahariImg from '../../assets/Itahari.png';

import { ArrowRight, CaretDown, Envelope, Calendar, MapPin, X, MapTrifold, Users } from 'phosphor-react';
import { getEvents } from '../../utils/api/eventApi';
import { getImageUrl } from '../../utils/imageUtils';
import { createPortal } from 'react-dom';
import { useLanguage } from '../../context/LanguageContext';

/* ─── LANGUAGE CONTENT ───────────────────────────────────────────────────── */

const content = {
 ne: {
  heroTitle: 'भोलिको इटहरी',
  heroAccent: 'भिजन २०५०',
  heroCampaign: 'अभियान',
  heroPlatform: 'डिजिटल प्लाटफर्म',
  heroDescription:
    'नगरको समृद्धि र दिगो विकासका लागि नागरिक अभियान',
  registerBtn: 'दर्ता गर्नुहोस्',
  learnBtn: 'थप जान्नुहोस्',

  heroEventBadge: 'आगामी कार्यक्रम',
  heroEventCta: 'विस्तृत हेर्नुहोस्',

  stats: [
    { num: '१', label: 'भिजन' },
    { num: '२५', label: 'वर्षको योजना' },
    { num: '∞', label: 'नगरवासीको साथ' },
  ],

  aboutEyebrow: 'हाम्रो लक्ष्य',
  aboutTitle: 'भोलिको इटहरीका लागि साझा गन्तव्य, योजना र पहल',
  aboutIntro:
    'इटहरीको दिगो विकासका लागि स्पष्ट गन्तव्य र त्यसका लागि योजना निर्माण र कार्यान्वयनका लागि पहल गर्नका लागि जनस्तरबाट थालिएको अभियान नै भोलिको इटहरी भिजन २०५० हो।',
  aboutDescription:
    'नगरको दीर्घकालिन विकास तबमात्र सुरु हुन्छ, जब नागरिकको भावनाका आधारमा प्राथमिकताका क्षेत्रहरु निर्धारण गरी दीर्घकालिन योजना बन्छ र इमान्दारितापूर्वक त्यसको कार्यान्वयन गरिन्छ।',
  aboutBtn: 'थप जान्नुहोस्',

  aboutFeatures: [
    {
      number: '०१',
      title: '25 years',
      desc: 'दीर्घकालीन दृष्टि',
    },
    {
      number: '०२',
      title: 'Citizen First',
      desc: 'योजना निर्माण',
    },
    {
      number: '०३',
      title: 'Result oriented',
      desc: 'कार्यान्वयन',
    },
  ],

  timelineEyebrow: 'कार्यक्रमहरू',
  timelineTitle: 'कार्यक्रमहरूको समयरेखा',
  timelineLoading: 'कार्यक्रमहरू लोड हुँदैछ…',
  timelineEmpty: 'कुनै कार्यक्रम उपलब्ध छैन।',
  timelinePast: 'विगतमा सम्पन्न',
  timelineUpcoming: 'आगामी योजना',
  timelineLive: 'हाल जारी',
  timelineViewAll: 'सबै हेर्नुहोस्',
  timelineViewAllLink: 'https://www.bholikoitahari.com/events',

  sectorsEyebrow: 'कार्यक्षेत्र',
  sectorsTitle: 'प्राथमिकता क्षेत्रहरू',
  sectorsSubtitle:
    'दिगो, समावेशी र समृद्ध इटहरी विकासका लागि पहिचान गरिएका मुख्य क्षेत्रहरू।',
  exploreAll: 'सबै क्षेत्रहरू हेर्नुहोस्',

  latestEventsEyebrow: 'नागरिक सहभागिता',
  latestEventsTitle: 'पछिल्ला कार्यक्रमहरू',
  viewAllEvents: 'सबै कार्यक्रम हेर्नुहोस्',
  defaultEventCategory: 'कार्यक्रम',
  viewDetails: 'विस्तृत हेर्नुहोस्',

  ctaEyebrow: 'अभियानमा सहभागिता जनाउनुहोस्',
  ctaHeading1: 'सहभागिता फार्म',
  ctaHeading2: 'भर्नुहोस्',
  ctaBody:
    'आफ्नो मत, विचार र योजना राख्नुहोस्। इटहरीको भविष्यका लागि तपाईको विचार र योगदान महत्वपूर्ण छ।',
  joinToday: 'आफै सहभागी बनुहोस्',
  submitContribution: 'इटहरीको लागि विचार दिनुहोस्',

  

},

  en: {
  heroTitle: 'Bholiko Itahari',
  heroAccent: 'Vision 2050',
  heroCampaign: 'Campaign',
  heroPlatform: 'Digital Platform',
  heroDescription:
    'A citizen campaign for the prosperity and sustainable development of the city',
  registerBtn: 'Register',
  learnBtn: 'Learn About Us',

  heroEventBadge: 'Upcoming Event',
  heroEventCta: 'View Details',

  stats: [
    { num: '1', label: 'Vision' },
    { num: '25', label: 'Year Roadmap' },
    { num: '∞', label: 'Civic Support' },
  ],

  aboutEyebrow: 'Our Goal',
  aboutTitle: 'A Shared Destination, Plan, and Initiative for Bholiko Itahari',
  aboutIntro:
    'Bholiko Itahari Vision 2050 is a grassroots campaign launched to set a clear destination for the sustainable development of Itahari, and to initiate the formulation and implementation of a plan to achieve it.',
  aboutDescription:
    "A city's long-term development can only begin once priority areas are identified based on citizens' sentiments, a long-term plan is built around them, and that plan is implemented with honesty and integrity.",
  aboutBtn: 'Learn More',

  aboutFeatures: [
    {
      number: '01',
      title: '25 years',
      desc: 'Long-term vision',
    },
    {
      number: '02',
      title: 'Citizen First',
      desc: 'Plan formulation',
    },
    {
      number: '03',
      title: 'Result oriented',
      desc: 'Implementation',
    },
  ],

  timelineEyebrow: 'Events',
  timelineTitle: 'Event Timeline',
  timelineLoading: 'Loading events…',
  timelineEmpty: 'No events available.',
  timelinePast: 'Completed',
  timelineUpcoming: 'Upcoming Plans',
  timelineLive: 'Currently Ongoing',
  // new: "View All" tab/link below timeline tabs
  timelineViewAll: 'View All',
  timelineViewAllLink: 'https://www.bholikoitahari.com/events',

  sectorsEyebrow: 'Scope',
  sectorsTitle: 'Priority Areas',
  sectorsSubtitle:
    'Key sectors identified for the sustainable, inclusive, and prosperous development of Bholiko Itahari.',
  exploreAll: 'Explore All Sectors',

  latestEventsEyebrow: 'Civic Participation',
  latestEventsTitle: 'Latest Events',
  viewAllEvents: 'View All Events',
  defaultEventCategory: 'Event',
  viewDetails: 'View Details',

  ctaEyebrow: 'Join the Campaign',
  ctaHeading1: 'Fill out the',
  ctaHeading2: 'Participation Form',
  ctaBody:
    'Share your voice, ideas, and plans. Your thoughts and contribution matter for the future of Itahari.',
  joinToday: 'Join Now',
  submitContribution: 'Share Your Idea for Itahari',

},
}

const STATUS_LABELS = {
  ne: { live: 'हालको', upcoming: 'आगामी', completed: 'सम्पन्न', past: 'विगत' },
  en: { live: 'Live Now', upcoming: 'Upcoming', completed: 'Completed', past: 'Past' },
};

const STATUS_CFG = {
  live:       { classes: 'bg-green-100 text-green-800 border-green-200', dotClass: 'bg-green-500 animate-pulse' },
  upcoming:   { classes: 'bg-blue-100 text-blue-800 border-blue-200',    dotClass: 'bg-blue-500' },
  predefined: { classes: 'bg-blue-100 text-blue-800 border-blue-200',    dotClass: 'bg-blue-500' },
  completed:  { classes: 'bg-slate-100 text-slate-600 border-slate-200', dotClass: 'bg-slate-400' },
  past:       { classes: 'bg-slate-100 text-slate-600 border-slate-200', dotClass: 'bg-slate-400' },
};

// normalize any stored status value to one of: live | upcoming | past
function normalizeEventStatus(rawStatus) {
  let status = rawStatus === 'predefined' ? 'upcoming' : (rawStatus || 'upcoming');
  if (status === 'current') status = 'live';
  if (status === 'completed') status = 'past';
  return status;
}

const dateLocale = (lang) => (lang === 'ne' ? 'en-NP' : 'en-US');

function StatusBadge({ status, language }) {
  const key = status === 'predefined' ? 'upcoming' : (status || 'upcoming');
  const cfg = STATUS_CFG[key] || STATUS_CFG.upcoming;
  const label = (STATUS_LABELS[language] || STATUS_LABELS.ne)[key] || key;
  return (
    <div className="absolute top-3 left-3">
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${cfg.classes}`}>
        <span className={`w-1.5 h-1.5 rounded-full ${cfg.dotClass}`} />
        {label}
      </span>
    </div>
  );
}

/* ─── HERO UPCOMING-EVENT CARD ──────────────────────────────────────────── */

function HeroEventCard({ event, language, t, navigate }) {
  if (!event) return null;

  const dateStr = event.date
    ? new Date(event.date).toLocaleDateString(dateLocale(language), {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : '';

  return (
    <div
      onClick={() => navigate(`/events/${event._id}`)}
      className="block w-full shrink-0 cursor-pointer overflow-hidden rounded-3xl border border-white/15 shadow-[0_20px_60px_rgba(0,0,0,0.35)] transition-transform duration-300 hover:-translate-y-1 sm:w-[460px] lg:w-[520px]"
    >
      <div className="relative h-[280px] w-full overflow-hidden sm:h-[380px] lg:h-[560px]">
        {event.imageUrl ? (
          <img
            src={getImageUrl(event.imageUrl)}
            alt={event.title}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-[#1e6b3a] to-[#0f3d20]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />

        <div className="absolute inset-x-0 bottom-0 flex flex-col gap-2 p-6">
          <h3 className="text-lg font-extrabold leading-snug text-white line-clamp-2">
            {event.title}
          </h3>

          <div className="flex flex-col gap-1.5 text-xs font-medium text-white/75">
            {dateStr && (
              <span className="flex items-center gap-1.5">
                <Calendar size={13} /> {dateStr}
              </span>
            )}
            {event.organizer && (
              <span className="flex items-center gap-1.5">
                <Users size={13} /> {event.organizer}
              </span>
            )}
            {event.location && (
              <span className="flex items-center gap-1.5">
                <MapPin size={13} /> {event.location}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Home = () => {
  const { language } = useLanguage();
  const t = content[language] || content.ne;
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [sectors, setSectors] = useState([]);
  const [loadingSectors, setLoadingSectors] = useState(true);
  const [sectorsError, setSectorsError] = useState(null);
  const [showAllSectors, setShowAllSectors] = useState(false);
  const FEATURED_COUNT = 8;
  const [hovTimeline, setHovTimeline] = useState(null);
   const [selectedEvent, setSelectedEvent] = useState(null); 
   const [hovCard, setHovCard] = useState(null);

  useEffect(() => {
    getEvents(null)
      .then((data) => {
        setEvents(Array.isArray(data) ? data : []);
        setLoadingEvents(false);
      })
      .catch(() => setLoadingEvents(false));
  }, []);

  useEffect(() => {
    let mounted = true;
    setLoadingSectors(true);
    api
      .get('/sectors')
      .then((res) => {
        if (!mounted) return;
        const data = Array.isArray(res.data) ? res.data : [];
        const mapped = data
          .map((s) => ({
            id: s._id || s.id,
            title: s.name || s.title || '',
            nepaliTitle: s.name || s.title || '',
            description: s.description || '',
            nepaliDescription: s.description || '',
            subSectors: Array.isArray(s.tags) ? s.tags.length : 0,
            icon: typeof s.icon === 'string' && s.icon.length > 1 ? s.icon : 'Building2',
            slug: s.slug || s.name || s._id || s.id,
            order: typeof s.order === 'number' ? s.order : 999,
          }))
          .sort((a, b) => (a.order || 0) - (b.order || 0));

        setSectors(mapped);
        setLoadingSectors(false);
      })
      .catch((err) => {
        if (!mounted) return;
        setSectorsError(err.message || 'Failed to load sectors');
        setLoadingSectors(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

 const latestEvents = events.slice(0, 5);
const featuredEvent = latestEvents[0] || null;
const smallEvents = latestEvents.slice(1);

  
  const heroEvent = useMemo(() => {
    const upcoming = events
      .filter((e) => normalizeEventStatus(e.status) === 'upcoming')
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    if (upcoming.length) return upcoming[0];

    const live = events.filter((e) => normalizeEventStatus(e.status) === 'live');
    return live[0] || null;
  }, [events]);

  return (
    <main className={`home page-enter home--${language}`}>
      {/* ════════════════════════════════════════════════
          HERO SECTION
      ════════════════════════════════════════════════ */}

      <section className="relative flex min-h-screen flex-col overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={itahariImg}
            alt="Itahari city view"
            className="h-full w-full object-cover"
          />

          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(135deg, rgba(20,83,45,0.93) 0%, rgba(20,83,45,0.76) 35%, rgba(15,22,35,0.82) 100%)',
            }}
          />

          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 39px, rgba(255,255,255,0.5) 39px, rgba(255,255,255,0.5) 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, rgba(255,255,255,0.5) 39px, rgba(255,255,255,0.5) 40px)',
            }}
          />
        </div>

<div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-between gap-10 px-6 pb-16 pt-28 lg:flex-row lg:px-8">          <div className="max-w-2xl">
            <h1
              className="mb-4 font-[var(--ff-nepali)] font-extrabold leading-tight text-white"
              style={{
                fontSize: 'clamp(2.6rem, 5.5vw, 4.4rem)',
                letterSpacing: '-0.02em',
              }}
            >
              {t.heroTitle}
              <br />
              <span className="text-amber-400">{t.heroAccent}</span>
              <br />
              {t.heroCampaign}
            </h1>

            <p className="mb-2 text-base font-semibold leading-relaxed text-white/80">
              {t.heroPlatform}
            </p>

            <p className="max-w-xl font-[var(--ff-nepali)] text-sm leading-loose text-white/65">
              {t.heroDescription}
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-xl border border-white/30 bg-orange-500 px-6 py-3 text-sm font-bold text-white backdrop-blur-sm transition-all hover:bg-white/20"
              >
                {t.learnBtn}
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap gap-10 border-t border-white/15 pt-9">
              {t.stats.map(({ num, label }) => (
                <div key={label}>
                  <p className="text-[1.7rem] font-extrabold leading-none text-white">
                    {num}
                  </p>

                  <p className="mt-1 font-[var(--ff-nepali)] text-xs uppercase tracking-widest text-white/55">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Upcoming event card — admin-added event, click through to its detail page */}
          <HeroEventCard event={heroEvent} language={language} t={t} navigate={navigate} />
        </div>

        <div className="relative z-10 flex animate-bounce justify-center pb-7">
          <CaretDown size={24} className="text-white/35" />
        </div>
      </section>

      {/* ════════════════════════════════════════════════
          EVENT TIMELINE
      ════════════════════════════════════════════════ */}

      <section className="bg-gradient-to-b from-white to-[#F8F7F4] py-20 px-6">
        <div className="mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <div className="mb-2 inline-flex items-center gap-2">
              <span className="h-[2px] w-5 rounded-full bg-[#2D7A3A]" />
              <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#2D7A3A]">
                {t.timelineEyebrow}
              </span>
              <span className="h-[2px] w-5 rounded-full bg-[#2D7A3A]" />
            </div>
            <h2 className="mt-1 text-2xl font-extrabold text-[#1A1815] md:text-3xl">
              {t.timelineTitle}
            </h2>
          </div>

         {loadingEvents ? (
  <div className="py-12 text-center">
    <p className="text-sm text-gray-400">{t.timelineLoading}</p>
  </div>
) : events.length === 0 ? (
  <div className="py-12 text-center">
    <p className="text-sm text-gray-400">{t.timelineEmpty}</p>
  </div>
) : (
  <EventCarousel
    events={events}
    language={language}
    onSelect={setSelectedEvent}
    labels={{
      past: t.timelinePast,
      live: t.timelineLive,
      upcoming: t.timelineUpcoming,
      viewDetails: t.viewDetails,
      eyebrow: t.timelineEyebrow,
    }}
  />
)}

<div className="mt-10 flex flex-wrap justify-center gap-6">
            {[
              [t.timelinePast, '#94a3b8'],
              [t.timelineUpcoming, '#f97316'],
              [t.timelineLive, '#166534'],
            ].map(([label, c]) => (
              <div key={label} className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full border-2" style={{ borderColor: c, background: 'white' }} />
                <span className="text-x font-medium text-gray-500">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* {selectedEvent && createPortal(
  <div className="event-modal-overlay" onClick={() => setSelectedEvent(null)}>
    <div className="event-modal" onClick={(e) => e.stopPropagation()}>
      <div className="event-modal__header">
        <span className="event-modal__category">
          {selectedEvent.sector || selectedEvent.category || t.timelineEyebrow}
        </span>
        <button className="event-modal__close" onClick={() => setSelectedEvent(null)}>
          <X size={18} />
        </button>
      </div>

      <h3 className="event-modal__title">{selectedEvent.title}</h3>

      <div className="event-modal__meta">
        <span>
          <Calendar size={14} />
          {selectedEvent.date
            ? new Date(selectedEvent.date).toLocaleDateString(language === 'ne' ? 'en-NP' : 'en-US')
            : '—'}
        </span>
        <span>
          <MapPin size={14} /> {selectedEvent.location || '—'}
        </span>
      </div>

      <p className="event-modal__desc">
        {selectedEvent.description || ''}
      </p>

      <button
        className="event-modal__cta"
        onClick={() => navigate(`/events/${selectedEvent._id}`)}
      >
        {language === 'ne' ? 'विस्तृत हेर्नुहोस्' : 'View Details'} →
      </button>
    </div>
  </div>,
  document.body
)} */}

      {/* ════════════════════════════════════════════════
          ABOUT / MISSION SECTION
      ════════════════════════════════════════════════ */}

      <section className="relative overflow-hidden bg-gradient-to-b from-white to-[#F8F7F4] py-20">
        <div className="pointer-events-none absolute left-[-80px] top-10 h-56 w-56 rounded-full bg-green-700/5 blur-2xl" />
        <div className="pointer-events-none absolute bottom-0 right-[-100px] h-72 w-72 rounded-full bg-green-700/10 blur-3xl" />

        <div className="container relative z-10 mx-auto px-6">
          <div className="grid items-center gap-10 rounded-[28px] border border-[#EEECEA] bg-white/85 p-8 shadow-[0_18px_55px_rgba(26,24,21,0.07)] backdrop-blur-md lg:grid-cols-[0.9fr_1.35fr] lg:p-12">
            <div>
              <div className="mb-4 inline-flex items-center gap-2">
                <span className="h-[2px] w-6 rounded-full bg-[#2D7A3A]" />
                <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#2D7A3A]">
                  {t.aboutEyebrow}
                </span>
              </div>

              <h2 className="max-w-md font-[var(--ff-nepali)] text-3xl font-extrabold leading-tight text-[#1A1815] md:text-4xl">
                {t.aboutTitle}
              </h2>

              <p className="mt-5 max-w-md font-[var(--ff-nepali)] text-base leading-8 text-[#5C5852]">
                {t.aboutIntro}
              </p>
            </div>

            <div>
              <p className="max-w-3xl font-[var(--ff-nepali)] text-base leading-8 text-[#5C5852]">
                {t.aboutDescription}
              </p>

              <div className="mt-7 grid gap-4 sm:grid-cols-3">
                {t.aboutFeatures.map((item) => (
                  <div
                    key={item.number}
                    className="rounded-2xl border border-[#C8E6CC] bg-[#EBF5ED] p-5 transition duration-300 hover:-translate-y-1 hover:border-[#2D7A3A] hover:bg-white hover:shadow-[0_14px_34px_rgba(45,122,58,0.12)]"
                  >
                    <span className="mb-4 inline-flex h-9 min-w-9 items-center justify-center rounded-full bg-white px-3 text-sm font-extrabold text-[#2D7A3A] shadow-sm">
                      {item.number}
                    </span>

                    <h3 className="text-sm font-extrabold text-[#1A1815]">
                      {item.title}
                    </h3>

                    <p className="mt-1 font-[var(--ff-nepali)] text-sm leading-6 text-[#5C5852]">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>

              <Link
                to="/about"
                className="mt-8 inline-flex items-center gap-2 rounded-xl bg-[#2D7A3A] px-5 py-3 text-sm font-extrabold text-white shadow-[0_12px_28px_rgba(45,122,58,0.22)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#1E5528] hover:shadow-[0_16px_36px_rgba(45,122,58,0.3)]"
              >
                {t.aboutBtn}
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════
          PRIORITY SECTORS
      ════════════════════════════════════════════════ */}

      {/* Priority Areas: fetch from existing API and render compact cards */}
      <section className="priority-sectors" aria-labelledby="priority-sectors-title">
        <div className="priority-sectors-container">
          <div className="priority-sectors__header">
            <div className="priority-sectors__eyebrow">{t.sectorsEyebrow}</div>
            <h2 className="priority-sectors__title" id="priority-sectors-title">{t.sectorsTitle}</h2>
            <p className="priority-sectors__subtitle">{t.sectorsSubtitle}</p>
          </div>

          {loadingSectors ? (
            <div className="py-12 text-center">
              <p className="text-sm text-gray-400">Loading sectors…</p>
            </div>
          ) : sectorsError ? (
            <div className="py-12 text-center">
              <p className="text-sm text-red-500">{sectorsError}</p>
            </div>
          ) : sectors.length === 0 ? (
            <div className="py-12 text-center">
              <p className="text-sm text-gray-400">No priority areas available.</p>
            </div>
          ) : (
            <>
              <div className="priority-sectors__grid" role="grid">
                {(showAllSectors ? sectors : sectors.slice(0, FEATURED_COUNT)).map((sector) => (
                  <div key={sector.id} role="gridcell">
                    <PrioritySectorCard sector={sector} language={language} />
                  </div>
                ))}
              </div>

              <div className="priority-sectors__cta">
                <Link to="/sectors" className="priority-sectors__cta-btn">
                  {t.exploreAll}
                  <ArrowRight />
                </Link>
              </div>
            </>
          )}
        </div>
      </section>

      <VoiceOfItahari language={language}/>

      {/* ════════════════════════════════════════════════
          CTA SECTION
      ════════════════════════════════════════════════ */}

      <section className="py-20 px-6 text-center" style={{ background: 'linear-gradient(135deg, #14532d 0%, #15803d 60%, #166534 100%)' }}>
        <div className="max-w-xl mx-auto">
          <p className="mb-3 text-xs font-bold uppercase tracking-widest text-amber-400">{t.ctaEyebrow}</p>
          <h2 className="mb-4 font-extrabold leading-tight text-white" style={{ fontSize: 'clamp(1.7rem, 3vw, 2.4rem)' }}>
            {t.ctaHeading1}<br />{t.ctaHeading2}
          </h2>
          <p className="mx-auto mb-9 max-w-md text-sm leading-loose text-white/70">
            {t.ctaBody}
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/volunteer"
              className="inline-flex items-center gap-2 rounded-xl bg-slate-100 px-6 py-3 text-sm font-bold text-green-800 shadow-lg transition-all duration-300 hover:bg-green-800 hover:text-white"
            >
              {t.joinToday} <ArrowRight size={15} />
            </Link>
            <Link
              to="/contributions"
              className="inline-flex items-center gap-2 rounded-xl border border-orange-600 bg-orange-600 px-6 py-3 text-sm font-bold text-white transition-all duration-300 hover:border-orange-700 hover:bg-orange-400"
            >
              <Envelope size={15} /> {t.submitContribution}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;